module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/select-dress-6dc714b68c10126fb4542c74012db12d.png";